export enum HappinessType {
    unsatisfied = 'unsatisfied',
    neutral = 'neutral',
    satisfied = 'satisfied',
}
